module.exports = __webpack_public_path__ + "img/trend-up.3fa4baea.svg";